import React from "react";

const Sidebar = ({ items }) => {

  return (
    <div>
      {items}
    </div>
  );
};

export default Sidebar;
